import {createAction} from '@reduxjs/toolkit'
import {ACTIVITY_BY_TIME, ProductivitySearchInputState} from 'interfaces'

// Productivity
export const setProductivityTitle = createAction<string>('setProductivityTitle')
export const resetProductivity = createAction('resetProductivity')

// Activity Time
export const setActivityByTimeFormat = createAction<ACTIVITY_BY_TIME>(
  'setActivityByTimeFormat',
)
export const resetActivityByTime = createAction('resetActivityByTime')

// Search
export const setProductivitySearchInputs =
  createAction<ProductivitySearchInputState>('setProductivitySearchInputs')
export const resetProductivitySearchInputs = createAction(
  'resetProductivitySearchInputs',
)

// Time Stamp
export const setTopCategoriesTimeStamp = createAction<number>(
  'setTopCategoriesTimeStamp',
)
